<script lang="ts">
  import { page } from '$app/stores';

  import { InstitutionType } from '@do/models';

  export let data: { [key: string]: any } | null = null;

  function slotExists(name: string) {
    return name in $$slots;
  }
</script>

{#if $page.data.isUFDA && slotExists('ufda')}
  <slot name="ufda" {data} />
{:else}
  {#if $page.data.configurations.type === InstitutionType.Agency}
    <slot name="agency" {data} />
  {/if}

  {#if $page.data.configurations.type === InstitutionType.Artist}
    <slot name="artist" {data} />
  {/if}

  {#if $page.data.configurations.type === InstitutionType.Gallery}
    <slot name="gallery" {data} />
  {/if}

  {#if $page.data.configurations.type === InstitutionType.Collector}
    <slot name="collector" {data} />
  {/if}

  {#if $page.data.configurations.type === InstitutionType.Curator}
    <slot name="curator" {data} />
  {/if}

  {#if slotExists('default')}
    <slot />
  {/if}
{/if}
